<template>
  <router-view />
</template>
  
<script>
export default {
  beforeRouteUpdate(to, from, next) {
    if (to.name == "venda-motivo-nao-venda") {
      next({ name: "ven-motivo-nao-venda-list" });
    } else {
      next();
    }
  },
  created() {
    if (this.$route.name == "venda-motivo-nao-venda") {
      this.$router.push({ name: "ven-motivo-nao-venda-list" });
    }
  },
};
</script>